import shopSelect from '@/components/decoration/data/shopSelect';
import storeSelect from '@/components/decoration/data/storeSelect';
import coupon from '@/components/decoration/data/coupon';
import combination from '@/components/decoration/data/combination';
import seckill from '@/components/decoration/data/seckill';
import promotionList from '@/components/decoration/data/promotionList';

export default [
    // shopSelect,
    // storeSelect,
    coupon,
    combination,
    seckill,
    promotionList,
]